/**
 * A curated list of MIME types used and supported through out the application.
 *
 * A full list can be found here:
 * - https://www.iana.org/assignments/media-types/media-types.xhtml
 * - https://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
 * - https://hg.nginx.org/nginx/raw-file/default/conf/mime.types
 */
export enum EMimeType {
  // image formats
  IMAGE_GIF = 'image/gif',
  IMAGE_JPG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  IMAGE_SVG = 'image/svg+xml',
  IMAGE_TIFF = 'image/tiff',
  IMAGE_WEBP = 'image/webp',

  // video formats
  VIDEO_MOV = 'video/quicktime',
  VIDEO_MP4 = 'video/mp4',
  VIDEO_OGG = 'video/ogg',
  VIDEO_WEBM = 'video/webm',

  // audio formats
  AUDIO_AAC = 'audio/aac',
  AUDIO_FLAC = 'audio/flac',
  AUDIO_MPG = 'audio/mpeg',
  AUDIO_OGG = 'audio/ogg',
  AUDIO_WAV = 'audio/wav',

  // document formats
  MARKDOWN = 'text/markdown',
  MICROSOFT_POWERPOINT_LEGACY = 'application/vnd.ms-powerpoint',
  MICROSOFT_POWERPOINT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  MICROSOFT_WORD_LEGACY = 'application/msword',
  MICROSOFT_WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PDF = 'application/pdf',

  // Machine readable data formats
  CSV = 'text/csv',
  JSON = 'application/json',
  MICROSOFT_EXCEL_LEGACY = 'application/vnd.ms-excel',
  MICROSOFT_EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
